import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";
import ActivitiesTable from "../Reuseables/DashboardComponents/ActivitiesTable";
import {
  OverallActivitiesResultsTableRef,
  OverallActivitiesResultsTable,
} from "../Reuseables/DashboardComponents/OverallActivitiesResultsTable";
import { useEffect, useRef, useState } from "react";
import {
  Compliance,
  ComplianceRef,
} from "../Reuseables/DashboardComponents/Compliance";
import { getTheme } from "../../theme";
import {
  TotalPainReports,
  TotalPainReportsRef,
} from "../Reuseables/DashboardComponents/TotalPainReports";
import {
  TotalUsers,
  TotalUsersRef,
} from "../Reuseables/DashboardComponents/TotalUsers";
import {
  TotalActivityLogs,
  TotalActivityLogsRef,
} from "../Reuseables/DashboardComponents/TotalActivityLogs";
import {
  UsersWithHighMLI,
  UsersWithHighMLIRef,
} from "../Reuseables/DashboardComponents/UsersWithHighMLI";
import {
  UsersWithHighPain,
  UsersWithHighPainRef,
} from "../Reuseables/DashboardComponents/UsersWithHighPain";
import { Project } from "../../types/project";
import { useOrganizationContext } from "../ContextProviders/OrganizationContext";
import { GroupByOverview, Role, Stage } from "../../types/enums";
import { getWorkspacesByOrgId } from "../../api/workspace";
import { Workspace } from "../../types/workspace";
import { Organization } from "../../types/organization";
import { getProjectsByWorkspaceId } from "../../api/project";
import { t } from "i18next";
import OverallIndustryResultsTable, {
  OverallIndustryResultsTableRef,
} from "../Reuseables/DashboardComponents/OverallIndustryResultsTable";
import { RoleComponentGuard } from "../Reuseables/Guards/RoleComponentGuard";
import { GenerateOverviewPPTXPopup } from "../MyProjectsPage/DashboardPage/Powerpoint/GenerateOverviewPPTXPopup";


export default function Home() {
  const {
    organizations,
    activeWorkspace,
  } = useOrganizationContext();
  const [groupByOption, setGroupByOption] = useState<GroupByOverview>(
    GroupByOverview.Workspace
  );
  const [isLoading, setIsLoading] = useState(false);

  const [selectedGroupByItem, setSelectedGroupByItem] = useState<string>();
  const [availableWorkspaces, setAvailableWorkspaces] = useState<Workspace[]>(
    []
  );
  const [availableWsProjects, setAvailableWsProjects] = useState<Project[]>([]);
  const [selectedWsProjectCode, setSelectedWsProjectCode] =
    useState<string>("");
  const [projectCodes, setProjectCodes] = useState<string[]>([]);
  const [powerpointPopup, setPowerpointPopup] = useState(false);

  const overallIndustryTable = useRef<OverallIndustryResultsTableRef>(null);
  const overallActivityTable = useRef<OverallActivitiesResultsTableRef>(null);
  const highMLI = useRef<UsersWithHighMLIRef>(null);
  const highpain = useRef<UsersWithHighPainRef>(null);
  const compliance = useRef<ComplianceRef>(null);
  const totalActivities = useRef<TotalActivityLogsRef>(null);
  const totalUsers = useRef<TotalUsersRef>(null);
  const totalPainReports = useRef<TotalPainReportsRef>(null);

  useEffect(() => {


    const fetchInitialProjects = async () => {
      setGroupByOption(GroupByOverview.Workspace);
      setSelectedGroupByItem(activeWorkspace.displayName ?? "");
      if (activeWorkspace.workspaceId) {
        let projects = await getProjectsByWorkspaceId(
          activeWorkspace.workspaceId
        );
        setAvailableWsProjects(projects);
        setSelectedWsProjectCode("all");
        setProjectCodes(projects.map((proj: Project) => proj.projectCode));
      } else {
        setAvailableWsProjects([]);
        setProjectCodes([]);
      }
    };
    if(activeWorkspace.projects){
       fetchInitialProjects();
    }
  }, [activeWorkspace]);

  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      if (
        activeWorkspace &&
        activeWorkspace.projects &&
        activeWorkspace.projects.length > 0
      ) {
        let workspaces: Workspace[] = [];
        for (const org of organizations) {
          if (org) {
            let _workspaces = await getWorkspacesByOrgId(org.id);
            workspaces = workspaces.concat(_workspaces);
          }
        }
        setAvailableWorkspaces(
          workspaces.sort((a, b) =>
            (a.displayName ?? "").localeCompare(b.displayName ?? "")
          )
        );
        setIsLoading(false);
      }
    };

    fetchData();
  }, [activeWorkspace, organizations]);

  const handleGroupByChange = (event: any) => {
    const {
      target: { value },
    } = event;
    const selectedValue = value as GroupByOverview; // Cast value to GroupByOverview
    setGroupByOption(selectedValue);
    setSelectedGroupByItem("");
    setAvailableWsProjects([]);
    setSelectedWsProjectCode("");
  };

  const handleProjectCodesChange = async (event: any) => {
    const {
      target: { value },
    } = event;

    switch (groupByOption) {
      case GroupByOverview.Organization:
        setSelectedGroupByItem(value);
        const selectedOrg: Organization | undefined = organizations.find(
          (org) => org.name === value
        );
        if (!selectedOrg) {
          throw new Error("Selected organization not found");
        }
        let selectedWorkspaces: Workspace[] = [];
        for (const ws of availableWorkspaces) {
          if (ws.organizationId === selectedOrg.id) {
            selectedWorkspaces = selectedWorkspaces.concat(ws);
          }
        }
        let selectedProjects: Project[] = [];
        if (selectedWorkspaces.length > 0) {
          for (const ws of selectedWorkspaces) {
            if (ws.workspaceId !== undefined) {
              const projs = await getProjectsByWorkspaceId(ws.workspaceId);
              selectedProjects = selectedProjects.concat(
                projs.filter((x: Project) => x.stage > Stage.NotStarted)
              );
            }
          }
          setProjectCodes(
            selectedProjects.map((proj: Project) => proj.projectCode)
          );
        }

        break;

      case GroupByOverview.Workspace:
        setSelectedGroupByItem(value);
        const selectedWs: Workspace | undefined = availableWorkspaces.find(
          (ws) => ws.displayName === value
        );
        if (!selectedWs) {
          throw new Error("Selected Workspace not found");
        }

        if (selectedWs.workspaceId !== undefined) {
          const projs = await getProjectsByWorkspaceId(selectedWs.workspaceId);
          const workspaceProjects = projs.filter(
            (x: Project) => x.stage > Stage.NotStarted
          );

          setAvailableWsProjects(workspaceProjects);
          setSelectedWsProjectCode("all");
          setProjectCodes(
            workspaceProjects.map((proj: Project) => proj.projectCode)
          );
        }
        break;

      default:
        break;
    }
  };

  const handleWsProjectChange = (event: any) => {
    const value = event.target.value;
    if (value === "all") {
      setSelectedWsProjectCode("all");
      setProjectCodes(availableWsProjects.map((proj) => proj.projectCode));
    } else {
      setSelectedWsProjectCode(value);
      setProjectCodes([value]);
    }
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 300,
      },
    },
  };

  const handlePPTX = async () => {
    setPowerpointPopup(true);
  };

  const theme = getTheme();
  return (
    <>
      <Grid
        container
        sx={{ flexDirection: "column" }}
        spacing={3}
        justifyContent={"space-between"}
        paddingLeft={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 6 }}
        paddingRight={{ xs: 2, sm: 2, md: 4, lg: 6, xl: 6 }}
      >
        <Grid item xs>
          <Grid container spacing={1} alignItems={"flex-end"}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    sx={{ color: theme.palette.text.primary }}
                  >
                    Overview Dashboard
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "normal",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    Overall usage statistics and projects' results
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
              {isLoading ? (
                <Skeleton
                  sx={{
                    borderRadius: "5px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                  }}
                  animation="pulse"
                  variant="rectangular"
                  height={50}
                  width={"100%"}
                ></Skeleton>
              ) : (
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>Group By</InputLabel>
                  <Select
                    sx={{ height: 50 }}
                    value={groupByOption || GroupByOverview.Organization} // Ensure value is always defined
                    MenuProps={MenuProps}
                    onChange={handleGroupByChange}
                    input={<OutlinedInput label="Group By" />}
                  >
                    {Object.values(GroupByOverview)
                      .filter((value) => typeof value === "string")
                      .map((obj) => (
                        <MenuItem key={obj} value={obj}>
                          <ListItemText primary={obj} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
              {isLoading ? (
                <Skeleton
                  sx={{
                    borderRadius: "5px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                  }}
                  animation="pulse"
                  variant="rectangular"
                  height={50}
                  width={"100%"}
                ></Skeleton>
              ) : (
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>{groupByOption}</InputLabel>
                  <Select
                    sx={{ height: 50 }}
                    value={selectedGroupByItem || []} // Ensure value is always defined
                    MenuProps={MenuProps}
                    onChange={handleProjectCodesChange}
                    input={
                      <OutlinedInput label={groupByOption || "Group By"} />
                    }
                  >
                    {groupByOption === GroupByOverview.Organization &&
                      organizations.map((org: Organization) => (
                        <MenuItem key={org.id} value={org.name}>
                          <ListItemText primary={org.name} />
                        </MenuItem>
                      ))}
                    {groupByOption === GroupByOverview.Workspace &&
                      availableWorkspaces.map((ws: Workspace) => (
                        <MenuItem key={ws.workspaceId} value={ws.displayName}>
                          <ListItemText primary={ws.displayName} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
              {groupByOption === GroupByOverview.Workspace &&
                (isLoading ? (
                  <Skeleton
                    sx={{
                      borderRadius: "5px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                    }}
                    animation="pulse"
                    variant="rectangular"
                    height={50}
                    width={"100%"}
                  ></Skeleton>
                ) : (
                  <FormControl sx={{ width: "100%" }}>
                    <InputLabel>Project</InputLabel>
                    <Select
                      sx={{ height: 50 }}
                      value={selectedWsProjectCode}
                      MenuProps={MenuProps}
                      onChange={handleWsProjectChange}
                      input={<OutlinedInput label={"Project"} />}
                      renderValue={(selected: string) => {
                        if (selected === "all") {
                          return `${t("all-projects")}`;
                        } else {
                          return selected.slice(0, 8); // Remember this is hardcoded to fit the projectCode length
                        }
                      }}
                    >
                      {availableWsProjects.length > 0 ? (
                        <MenuItem key={"all"} value={"all"}>
                          <ListItemText primary={`${t("all-projects")}`} />
                        </MenuItem>
                      ) : (
                        <Typography
                          alignContent={"center"}
                          variant="caption"
                        >{`${t("no-active-projects-available")}`}</Typography>
                      )}
                      {availableWsProjects.map((proj: Project) => (
                        <MenuItem
                          key={proj.projectCode}
                          value={proj.projectCode}
                        >
                          <ListItemText
                            primary={proj.projectCode}
                            secondary={proj.projectName}
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ))}
            </Grid>
          </Grid>
        </Grid>
        <RoleComponentGuard roles={[Role.PrecureAdmin]}>
          <Grid item xs>
            <Button
              variant="contained"
              sx={{ float: "right" }}
              onClick={handlePPTX}
            >
              Generate PPTX
            </Button>
          </Grid>
        </RoleComponentGuard>
        <Grid item xs>
          <Divider sx={{ borderBottomWidth: 1 }} />
        </Grid>

        {projectCodes.length > 0 ? (
          <>
            <Grid item>
              <Grid
                container
                spacing={3}
                sx={{
                  flexDirection: {
                    xs: "column",
                    sm: "column",
                    md: "row",
                    lg: "row",
                    xl: "row",
                  },
                }}
              >
                <Grid item xs>
                  <TotalPainReports
                    ref={totalPainReports}
                    projectCodes={projectCodes}
                    height={150}
                  />
                </Grid>

                <Grid item xs>
                  <TotalUsers
                    ref={totalUsers}
                    projectCodes={projectCodes}
                    height={150}
                  />
                </Grid>

                <Grid item xs>
                  <TotalActivityLogs
                    ref={totalActivities}
                    projectCodes={projectCodes}
                    height={150}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12} lg={5} xl={5}>
                  <Compliance
                    ref={compliance}
                    projectCodes={projectCodes}
                    height={350}
                  />
                </Grid>

                <Grid item xs>
                  <ActivitiesTable projectCodes={projectCodes} height={350} />
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Typography
                variant="h4"
                marginBottom={2}
                sx={{ color: theme.palette.text.secondary }}
              >
                Overall Results
              </Typography>
            </Grid>
            <Grid item xs>
              {/* <Paper sx={{ borderRadius: "5px", padding: "0 10px" }}> */}
              <Grid
                container
                spacing={5}
                sx={{
                  flexDirection: "column",
                }}
              >
                <Grid item>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <UsersWithHighMLI
                        ref={highMLI}
                        height={200}
                        projectCodes={projectCodes}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                      <UsersWithHighPain
                        ref={highpain}
                        height={200}
                        projectCodes={projectCodes}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <Grid container spacing={2} flexDirection={"column"}>
                    <Grid item>
                      <Typography marginLeft={1} marginTop={1} variant="h5">
                        By Activity
                      </Typography>
                    </Grid>
                    <Grid xs item>
                      <OverallActivitiesResultsTable
                        ref={overallActivityTable}
                        height={400}
                        projectCodes={projectCodes}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <Grid container spacing={2} flexDirection={"column"}>
                    <Grid item>
                      <Typography marginLeft={1} marginTop={1} variant="h5">
                        By Industry
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <OverallIndustryResultsTable
                        ref={overallIndustryTable}
                        height={250}
                        projectCodes={projectCodes}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {/* </Paper> */}
            </Grid>
          </>
        ) : (
          <Grid
            item
            xs
            alignItems={"center"}
            alignContent={"center"}
            justifyContent={"center"}
            justifyItems={"center"}
          >
            {/* <Typography variant="h5"> Select an option in the filters above</Typography> */}
          </Grid>
        )}
        {powerpointPopup && (
          <GenerateOverviewPPTXPopup
            handleClose={() => setPowerpointPopup(false)}
            open={powerpointPopup}
            activities={overallActivityTable.current?.getRows() ?? []}
            complianceProcentage={compliance.current?.getCompliantUsers() ?? 0}
            numOfActivityLogs={
              totalActivities.current?.getActivityLogs()[0] ?? 0
            }
            numOfPain={totalPainReports.current?.getData()[0] ?? 0}
            numOfUsers={totalUsers.current?.getData()[0] ?? 0}
            industryBenchmarks={overallIndustryTable.current?.getRows() ?? []}
          />
        )}
      </Grid>
    </>
  );
}
